import { VideoTemplateStateContent } from '../../types';

export function hasWatermark(state: VideoTemplateStateContent) {
  const { watermark } = state;

  return !!watermark;
}
